import React, { Fragment } from 'react';
import walking9 from '../../../images/walking9.png';
import walking10 from '../../../images/walking10.jpg';
import walking11 from '../../../images/walking11.jpg';
import walking12 from '../../../images/walking12.png';

const AccessByCarNYC = () => (
  <Fragment>
    <div>
      <img
        className="faq-image-compress"
        src={walking9}
        alt="Parking Lot"
      />
      <p>The parking lot entrance/exit is on 46th Ave.</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking10}
        alt="Parking Lot"
      />
      <p>
        Press the green button and take a ticket for the gate to open.
        <b>
          Don’t worry, you will not pay for parking if you have a valid
          booking.
        </b>
      </p>
      <p>
        Drive all the way up to floor 6 where you will find the Autzu
        vehicles, and park your car in the parking spot you have been
        assigned to.
      </p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking11}
        alt="Parking Lot"
      />
      <p>
        Upon exit, give your parking ticket to the 24-hour Quik Park
        parking lot associate{' '}
      </p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking12}
        alt="Parking Lot"
      />
      <p>
        Show proof of your valid booking at&nbsp;
        <a
          className="faq__panel--link"
          href="http://www.autzu.com/mybookings">
          www.autzu.com/mybookings
        </a>
        &nbsp; so they can waive the parking costs and permit you to exit.
      </p>
    </div>
  </Fragment>
);

export default AccessByCarNYC;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccessByCarNYC.js